import { useEffect, useState } from "react";
import { Button, InlineStack, Select, TextField } from "@shopify/polaris";
import supabase from "../../supabase-client";
import { UserAuth } from "../../context/AuthContext";
import { rpcError } from "../../utility/egresos";

// Egreso category, from the managed list (egreso_categories). Whoever
// authorizes payments can add one on the spot; nobody types free text.
const ADD = "__add__";

export function useEgresoCategories() {
  const [list, setList] = useState([]);
  const reload = async () => {
    const { data } = await supabase
      .from("egreso_categories")
      .select("name")
      .eq("active", true)
      .order("position")
      .order("name");
    setList((data || []).map((c) => c.name));
  };
  useEffect(() => {
    reload();
  }, []);
  return [list, reload];
}

export default function CategorySelect({ value, onChange, categories, onAdded, label = "Categoría", requiredIndicator, disabled }) {
  const { hasPermission } = UserAuth();
  const canAdd = !!hasPermission?.("services.pay");
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // A value no longer on the list (renamed elsewhere) still shows.
  const names = value && !categories.includes(value) ? [value, ...categories] : categories;
  const options = [
    { label: "Elige una categoría", value: "", disabled: true },
    ...names.map((c) => ({ label: c, value: c })),
    ...(canAdd ? [{ label: "+ Agregar categoría…", value: ADD }] : []),
  ];

  const add = async () => {
    setBusy(true);
    setError(null);
    const { data, error: err } = await supabase.rpc("add_egreso_category", { p_name: name });
    setBusy(false);
    if (err) return setError(rpcError(err));
    await onAdded?.();
    onChange(data);
    setAdding(false);
    setName("");
  };

  if (adding) {
    return (
      <TextField
        label={label}
        requiredIndicator={requiredIndicator}
        value={name}
        onChange={setName}
        autoComplete="off"
        autoFocus
        placeholder="Nueva categoría"
        error={error || undefined}
        connectedRight={
          <InlineStack gap="100" wrap={false}>
            <Button onClick={add} loading={busy} disabled={!name.trim()}>
              Agregar
            </Button>
            <Button variant="tertiary" onClick={() => setAdding(false)}>
              Cancelar
            </Button>
          </InlineStack>
        }
      />
    );
  }

  return (
    <Select
      label={label}
      requiredIndicator={requiredIndicator}
      options={options}
      value={value || ""}
      disabled={disabled}
      onChange={(v) => (v === ADD ? setAdding(true) : onChange(v))}
    />
  );
}
